import { Color, Icon, NavItem } from '@billy/design-system'
import { TFunction } from 'i18next'

import { EmberRoute } from '../../../../../enums/emberRoute'

interface GetItemsProps {
  t: TFunction
  isUmbrella: boolean
  shouldShowUserSettings: boolean
  shouldShowSettings: boolean
  shouldShowSubscription: boolean
}

export const getItems = ({
  t,
  isUmbrella,
  shouldShowUserSettings,
  shouldShowSettings,
  shouldShowSubscription,
}: GetItemsProps) => {
  const items: NavItem<EmberRoute | string>[] = [
    {
      id: 'logout',
      children: t('navigation.menu.organization.label.logout'),
      value: EmberRoute.Logout,
      iconLeft: 'logout',
    },
  ]

  if (shouldShowSubscription) {
    items.unshift({
      id: 'subscription',
      children: t('navigation.menu.organization.label.subscription'),
      value: EmberRoute.SettingsSubscription,
      leftDecoration: <Icon icon="iteration" color={Color.Grey500} />,
    })
  }

  if (shouldShowSettings) {
    items.unshift({
      id: 'settings',
      children: t('navigation.menu.organization.label.settings'),
      value: EmberRoute.SettingsOrganization,
      iconLeft: 'settings',
    })
  }

  if (shouldShowUserSettings) {
    items.unshift({
      id: 'profile',
      children: t('navigation.menu.organization.label.profile'),
      value: isUmbrella ? EmberRoute.SettingsUserUmbrella : EmberRoute.SettingsUser,
      iconLeft: 'userRound',
    })
  }

  return { items }
}
